.mf-proactive-case-closure {
  display: block;
}

.mf-proactive-case-closure__loader {
  padding: 50px;
  position: relative;
}

.mf-proactive-case-closure__container {
  max-width: 700px;
  margin: 0 auto;
}

.mf-proactive-case-closure__introduction {
  text-align: var(--mf-service-calls-intro-align, center);
}

.mf-proactive-case-closure fieldset {
  border: 0;
  margin: 0;
  padding: 0;
}

.mf-proactive-case-closure__question-container {
  padding: var(--mf-service-calls-question-container-padding, 30px 60px);
}

.mf-proactive-case-closure__question {
  text-align: var(--mf-service-calls-question-align, center);
  font-family: Frutiger-Light, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  font-size: 23px;
}

@media only screen and (width <= 1439px) {
  .mf-proactive-case-closure__question {
    font-size: var(--mf-service-calls-question-font-size-mobile, 20px);
  }
}

@media only screen and (width >= 1920px) {
  .mf-proactive-case-closure__question {
    font-size: 28px;
  }
}

.mf-proactive-case-closure__radio-buttons-container {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
}

.mf-proactive-case-closure__radio-buttons-container::before,
.mf-proactive-case-closure__radio-buttons-container::after {
  content: "";
  display: block;
  width: var(--mf-service-calls-radio-button-container-before-width, 100%);
}

.mf-proactive-case-closure__radio-buttons {
  display: flex;
  flex-direction: row;
  justify-content: var(--mf-service-calls-radio-button-justify-content, center);
  flex-wrap: wrap;
  gap: 10px;
  width: var(--mf-service-calls-radio-buttons-width, auto);
}

@media (min-width: 512px) {
  ux-modal-content .mf-proactive-case-closure {
    margin: 0 60px;
  }

  .mf-proactive-case-closure__radio-buttons-container {
    flex-direction: column;
  }

  .mf-proactive-case-closure__radio-buttons {
    text-align: var(--mf-service-calls-radio-button-align, center);
  }
}

.mf-proactive-case-closure ux-radio-button {
  width: var(--mf-service-calls-radio-button-width, 100%);
}

@media (min-width: 512px) {
  .mf-proactive-case-closure ux-radio-button {
    width: 40%;
  }
}

.mf-proactive-case-closure__button-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 900px;
  margin: 0 auto;
}

@media (min-width: 512px) {
  .mf-proactive-case-closure__button-container {
    margin-top: 40px;
    justify-content: space-between;
    flex-direction: row;
  }
}
